import { useDispatch } from 'react-redux';
import { useAsyncAction } from 'Hooks/Common';
import { SignUpWithConfirmCodeTemporary } from 'Interfaces/Auth';
import { $actions } from 'Store/ducks';

export default () => {
  const dispatch = useDispatch();

  return useAsyncAction((payload: SignUpWithConfirmCodeTemporary) =>
    $actions.user.confirmTemporary(dispatch, payload),
  );
};
